import React from "react";
import { Link } from "react-router-dom";

const Logoo = () => {
  return (
    <div
  className="logo-box"
  style={{
    display: "flex",
    alignItems: "center",
    height: "70px",
    marginLeft: "-70px"
  }}
>

  <Link to="/" className="logo text-center admin_lg">

    <span className="logo-lg">
      <img
        src="assets/images/VedMG_logo.png"
        alt="logo"
        style={{
          maxHeight: "42px",
          width: "auto",
          objectFit: "contain"
        }}
      />
    </span>

  </Link>

</div>
  );
};

export default Logoo;